import React, { useCallback, useRef, useState } from 'react';
import { DocEditor } from '../../../DocEditor';
import IconPicker from '../../../SprintDetail/shared/IconPicker';
import { renderIcon } from '../../../SprintDetail/FlowchartView/utils/renderIcon';
import { formatRelativeDate } from '../../relativeDate';

/**
 * Editable master doc article: icon, title, tags/meta, and block editor.
 */
const DocFullPageContent = ({
  docId,
  doc,
  title,
  blocks,
  onTitleChange,
  onTitleKeyDown,
  onIconChange,
  onBlocksChange,
  onOpenDoc,
  resolveDocMeta,
  libraryDocs,
  snippetBacklinks,
  resolveVariable,
  scopedVariables,
  onCreateVariable,
  docVariables,
  onDocVariablesChange,
  variablesColumnWidths,
  onVariablesColumnWidthsChange,
}) => {
  const iconBtnRef = useRef(null);
  const [showIconPicker, setShowIconPicker] = useState(false);
  const [iconPickerPosition, setIconPickerPosition] = useState(null);

  const handleIconClick = useCallback(() => {
    if (iconBtnRef.current) {
      const rect = iconBtnRef.current.getBoundingClientRect();
      setIconPickerPosition({ x: rect.left, y: rect.bottom + 8 });
    }
    setShowIconPicker(true);
  }, []);

  return (
    <article className="doc-fullpage__doc">
      <button
        ref={iconBtnRef}
        className="doc-fullpage__icon doc-fullpage__icon--editable"
        onClick={handleIconClick}
        title="Change icon"
      >
        {renderIcon(doc.icon, { size: '52px', fallback: <span>📄</span> })}
      </button>

      {showIconPicker && (
        <IconPicker
          currentIcon={doc.icon}
          onIconChange={onIconChange}
          onIconDeleted={() => onIconChange(null)}
          onClose={() => setShowIconPicker(false)}
          position={iconPickerPosition}
        />
      )}

      <input
        className="doc-fullpage__title-input"
        value={title}
        onChange={onTitleChange}
        onKeyDown={onTitleKeyDown}
        placeholder="Untitled Doc"
        aria-label="Doc title"
      />

      <div className="doc-fullpage__meta">
        {(doc.tags || []).map((tag) => (
          <span key={tag} className="doc-card__tag">{tag}</span>
        ))}
        <span className="doc-fullpage__updated">
          Updated {formatRelativeDate(doc.updatedAt)}
        </span>
      </div>

      <div className="doc-fullpage__body">
        <DocEditor
          docId={docId}
          blocks={blocks}
          onChange={onBlocksChange}
          onOpenDoc={onOpenDoc}
          resolveDocMeta={resolveDocMeta}
          availableDocs={libraryDocs}
          snippetBacklinks={snippetBacklinks}
          resolveVariable={resolveVariable}
          availableVariables={scopedVariables}
          onCreateVariable={onCreateVariable}
          docVariables={docVariables}
          onDocVariablesChange={onDocVariablesChange}
          variablesColumnWidths={variablesColumnWidths}
          onVariablesColumnWidthsChange={onVariablesColumnWidthsChange}
        />
      </div>
    </article>
  );
};

export default DocFullPageContent;
